import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
	position: fixed;
	top: 40px;
	left: 0;
	right: 0;
	z-index: 10;
	max-width: 400px;
	width: 90%;
	// height: 95vh;
	margin: 0 auto;
	padding-bottom: 3rem;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.white};
`;

export const Header = styled.div`
	height: 45px;
	padding: 10px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.BeauBlue};
	color: ${(props) => props.theme.colors.Jet};
`;

export const Body = styled.div`
	padding: 0 10px;
	color: ${(props) => props.theme.colors.Jet};
`;

export const Input = styled.input`
	height: 32px;
	width: 70px;
	margin: 0 1rem;
	border: 0;
	border-bottom: 1px solid #303030;
	border-radius: 0;
	text-align: center;
`;

export const Minus = styled.div`
	position: relative;
	height: 32px;
	width: 32px;
	border: 1px solid ${(props) => props.theme.colors.primary};
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.white};
	text-align: center;
	cursor: pointer;

	&:before {
		position: absolute;
		top: 14px;
		left: 8px;
		display: inline-block;
		width: 14px;
		content: ' ';
		border: 1px solid ${(props) => props.theme.colors.primary};
		border-radius: 2px;
	}
`;

export const Plus = styled.div`
	position: relative;
	height: 32px;
	width: 32px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	text-align: center;
	cursor: pointer;

	&:before {
		position: absolute;
		top: 0;
		left: 7px;
		display: inline-block;
		content: '+';
		font-size: 32px;
		color: ${(props) => props.theme.colors.white};
	}
`;

export const FinishBtn = styled(Button)`
	width: 220px;
	height: 40px;
	margin-top: 1rem;
`;
